import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const FooterActions = ({ interviewName }) => {
  const navigate = useNavigate();
  const { uuid } = useParams();

  return (
    <div className="flex justify-end mt-6">
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded dark:bg-blue-600"
        onClick={() =>
          navigate(`/organization/interviews/${uuid}/reports`, {
            state: { interviewName },
          })
        }
      >
        View Student Reports
      </button>
    </div>
  );
};

export default FooterActions;
